import React, { useState, useEffect } from 'react';
import {
	Typography,
	TextField,
	Button,
	Grid2 as Grid,
	Autocomplete,
} from '@mui/material';

import { Container } from '../components/_atoms';
import { APIService } from '../services/apiService';
import { SchoolDTO } from '../DTO/SchoolDTO';
import { HOME_SCHOOL_ID } from '../constants';
import CourseMappingsGrid from '../components/CourseMappingsGrid';

const CourseMappings = () => {
	const [schools, setSchools] = useState<SchoolDTO[]>([]);
	const [filters, setFilters] = useState({
		schoolId: '',
		exchangeCourse: '',
		homeCourse: '',
		year: '',
	});

	const api = new APIService();

	useEffect(() => {
		loadSchools();
	}, []);

	const loadSchools = async () => {
		try {
			const schoolsData = await api.getSchools();
			setSchools(schoolsData.filter((s) => s.id !== HOME_SCHOOL_ID));
		} catch (error) {
			console.error('Failed to load schools:', error);
		}
	};

	const handleFilterChange = (field: string, value: string | number) => {
		setFilters((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handleClearFilters = () => {
		setFilters({
			schoolId: '',
			exchangeCourse: '',
			homeCourse: '',
			year: '',
		});
	};

	return (
		<>
			<Typography
				gutterBottom
				sx={{ marginTop: '5px' }}
				variant="h4"
				align="center"
			>
				Course Mappings
			</Typography>

			{/* Filter Section */}
			<Container>
				<Grid container spacing={2} sx={{ marginBottom: 2 }}>
					<Grid size={{ xs: 12, sm: 6, md: 3 }}>
						<Autocomplete
							getOptionLabel={(s) =>
								`${s.name} - ${s.country?.name || ''}`
							}
							value={
								schools.find(
									(s) => s.id === Number(filters.schoolId)
								) || null
							}
							fullWidth
							onChange={(e, school) =>
								school &&
								handleFilterChange('schoolId', school.id)
							}
							isOptionEqualToValue={(option, value) =>
								option.id === value.id
							}
							options={
								schools?.filter(
									(s) => s.id != HOME_SCHOOL_ID
								) || []
							}
							renderInput={(params) => (
								<TextField
									{...params}
									label="University"
									variant="outlined"
								/>
							)}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 3 }}>
						<TextField
							fullWidth
							label="Home Course"
							value={filters.homeCourse}
							onChange={(e) =>
								handleFilterChange('homeCourse', e.target.value)
							}
							placeholder="Course code or title starts with..."
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 3 }}>
						<TextField
							fullWidth
							label="Exchange Course"
							value={filters.exchangeCourse}
							onChange={(e) =>
								handleFilterChange(
									'exchangeCourse',
									e.target.value
								)
							}
							placeholder="Course code or title starts with..."
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 3 }}>
						<TextField
							fullWidth
							label="Year"
							type="number"
							value={filters.year}
							onChange={(e) =>
								handleFilterChange('year', e.target.value)
							}
						/>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<Button variant="outlined" onClick={handleClearFilters}>
							Clear Filters
						</Button>
					</Grid>
				</Grid>
			</Container>

			<Container>
				<div style={{ marginTop: '10px' }}>
					<CourseMappingsGrid
						schoolId={
							filters.schoolId
								? Number(filters.schoolId)
								: undefined
						}
						exchangeCourse={filters.exchangeCourse || undefined}
						homeCourse={filters.homeCourse || undefined}
						year={filters.year ? Number(filters.year) : undefined}
					/>
				</div>
			</Container>
		</>
	);
};

export default CourseMappings;
